import React, { useRef } from "react";
import { message, Col, Form } from "antd";
import { IIntroductionsDetail, IIntroductionsFormFields } from "../introductionsService";
import { useIntroductionsModel } from "../introductionsModel";
import { IYhFormRef, FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YhForm } from "@/components/YhFormBox";
import { YHDrawer } from "@/components/YhDrawer";
import BraftEditor, { ControlType, ExtendControlType } from 'braft-editor'
import 'braft-editor/dist/index.css';
import { getBaseUploadData, getBaseImgUploadUrl, getBaseImgLookUrl } from "@/utils/constants";
import axios from "axios";

const controls: ControlType[] = [
    'undo',
    'redo',
    'bold',
    'font-size',
    'blockquote',
    'line-height',
    'letter-spacing',
    'text-color',
    'italic',
    'underline',
    'strike-through',
    'superscript',
    'subscript',
    'text-color',
    'separator',
    'separator',
    'list-ol',
    'list-ul',
    'headings',
    'text-indent',
    'text-align',
    'hr',
    'media',
    'clear'
]

export function DetailDrawer() {
    const { introductionsDrawer: { visible, mode }, setIIntroductionsDrawer, insertIntroductions, editIntroductions, getSelectedRowData } = useIntroductionsModel();
    const formRef = useRef<IYhFormRef>();
    const formVal: IIntroductionsDetail = mode === "add" ? {} : getSelectedRowData();

    const onCancel = () => {
        setIIntroductionsDrawer();
    }

    //图片变更缓存保留  保留缓存及回显表单
    const onSetFieldsValue = (formValues: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(formValues);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: IIntroductionsFormFields) => {
            //查看模式直接关闭弹框
            if (mode === "look") {
                onCancel()
                return;
            }
            let data = {
                ...val,
                photo: typeof val.photo === "string" ? val.photo : val?.photo?.join(),
                qrCode: typeof val.qrCode === "string" ? val.qrCode : val?.qrCode?.join(),
                profiles: val.profiles?.toText().trim().replace(/^a/, '').replace(/[\r\n]+/g, ''),
                html: val.profiles?.toHTML().replace(/<p><\/p>/g, '<p style="height:20px"></p>')
            }
            mode === "edit" ? editIntroductions(data) : insertIntroductions(data);
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm<IIntroductionsFormFields> = {
        formRef,
        labelCol: { span: 2 },
        formValues: { ...formVal, profiles: BraftEditor.createEditorState(formVal?.html ?? formVal?.profiles) },
        disabled: mode === "look",
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "业务名称",
                fieldName: "name",
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "业务图片",
                fieldName: "photo",
                span: 24,
                md5List: formVal.photo ? formVal.photo.split(",") : [],
                onSetFieldsValue,
                photoNum: 20
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "二维码",
                fieldName: "qrCode",
                span: 24,
                md5List: formVal.qrCode ? [formVal.qrCode] : [],
                onSetFieldsValue,
                photoNum: 1
            },
            // {
            //     type: FormItemTypeEnum.TextArea,
            //     fieldLabel: "业务简介",
            //     fieldName: "profiles",
            //     span: 24,
            // },
        ]
    };
    const uploadImage = async (formData: FormData) => {
        try {
            // 添加上传所需的其他参数
            const uploadData = getBaseUploadData();
            Object.keys(uploadData).forEach(key => {
                formData.append(key, uploadData[key as keyof typeof uploadData] as string);
            });
            const { data } = await axios.post(getBaseImgUploadUrl(), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (data.retCode === 0) {
                return getBaseImgLookUrl(data.retData);
            } else {
                throw new Error(data.msg || '上传失败');
            }
        } catch (error) {
            message.error('图片上传失败：' + (error instanceof Error ? error.message : '未知错误'));
            throw error;
        }
    }
    return (
        <YHDrawer
            {...{
                title: `业务介绍${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: mode === "look" ? "确定" : "保存",
                onOk: onSubmit,
                width: 800
            }}
        >
            <YhForm {...formConfig}>
                <Col span={24} key="profiles" style={{marginTop:"4px"}}>
                    <Form.Item
                        style={{ flexWrap: "nowrap" }}
                        label="业务简介"
                        name="profiles"
                        labelCol={{
                            span: 2
                        }}
                    >
                        <BraftEditor
                            readOnly={mode === 'look'}
                            style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                            className="my-editor"
                            controls={controls}
                            placeholder="请输入正文内容"
                            media={{
                                uploadFn: async (param) => {
                                    try {
                                        // 这里实现图片上传逻辑
                                        const formData = new FormData();
                                        formData.append('file', param.file);

                                        // 调用你的上传API
                                        const res = await uploadImage(formData);
                                        // 上传成功后调用
                                        param.success({
                                            url: res,
                                            meta: {
                                                id: res,
                                                title: param.file.name,
                                                alt: param.file.name,
                                                loop: false,
                                                autoPlay: false,
                                                controls: false,
                                                poster: ''
                                            }
                                        })
                                    } catch (error) {
                                        // 上传失败调用
                                        param.error({
                                            msg: '上传失败'
                                        })
                                    }
                                },
                                accepts: {
                                    image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
                                    video: false,
                                    audio: false
                                }
                            }}
                        />
                    </Form.Item>
                </Col>
            </YhForm>
        </YHDrawer>
    )
}
